import React, { Fragment, useState, useEffect } from 'react';
import styles from './Navbar.module.css';
import HamburgerNavItems from './HamburgerNavItems';
import NavbarItems from './NavbarItems';
import MobileNavBar from './MobileNavBar';
import NavbarLogo from './NavbarLogo';

const Navbar = () => {
  // set the state of navbar hamurger menu icon
  const navClickHandler = () => setClick(!click);
  const [click, setClick] = useState(true);
  const closeMobileMenu = (event) => setClick(false);
  const [navBarCollapsed, setNavBarCollapsed] = useState(true);

  // Sets the navbar to show or not when in smaller screen mode.
  const showNavMenu = () => {
    if (window.innerWidth < 700) {
      setNavBarCollapsed(true);
    } else {
      setNavBarCollapsed(false);
    }
  };

  // Needed to work. Cleanup the listneners.
  useEffect(() => {
    window.addEventListener('resize', showNavMenu);
    return () => {
      window.addEventListener('resize', showNavMenu);
    };
  }, []);

  return (
    <Fragment>
      <div>
        <NavbarLogo />

        <nav className={styles.nav}>
          <NavbarItems />
          {navBarCollapsed ? (
            <div onClick={navClickHandler}>
              {!click ? (
                <div>
                  <MobileNavBar />
                </div>
              ) : (
                <div>
                  <MobileNavBar />
                  <HamburgerNavItems />
                </div>
              )}
            </div>
          ) : (
            <div>
              <div onClick={closeMobileMenu}>
                <MobileNavBar />
              </div>
            </div>
          )}
        </nav>
      </div>
    </Fragment>
  );
};

export default Navbar;
